import Vue from 'vue/dist/vue';
import productcard from '../components/products/products';
import multipleproducts from '../components/products/multiple-products';

if (document.querySelector('.dashboard-components')) {
    // eslint-disable-next-line
    new Vue({
        el: '.dashboard-components',
        components: {
            productcard: productcard,
            multipleproducts: multipleproducts,
        },
    });
}



// WEBPACK FOOTER //
// ./app/js/modules/vue/vues/dashboard-components.js